const validHosts = [
  'https://movieassets.erotik.com',
  'https://performerimages.erotik.com',
  'https://assets.erotik.com',
  'https://m30.dvdl.net',
  'https://p30.dvdl.net',
  'https://i30.dvdl.net',
];

// const CDN_URL_MATCHER = /^https:\/\/((p3|i3|[^pi])[^/]*)\/([^.]+)\/([^?]+).*/i;
const sizes = [
  200,
  300,
  400,
  600,
  900,
  1200,
  1920,
  2840,
];

const extractParts = (url) => {
  let hostname = '';
  let file = '';
  const length = url.length;
  let i = 0;
  let count = 0;

  for (; i < length; i += 1) {
    switch (true) {
      default:
        file += url[i];
        break;

      case url[i] === ':':
        break;

      case url[i] === '/':
        file = '';
        count += 1;
        break;

      case count === 2:
        hostname += url[i];
        break;
    }
  }

  const folder = url
    .replace(`https://${hostname}/`, '')
    .replace(`/${file}`, '');

  return {
    hostname,
    file,
    folder,
  };
};

const isPlaceholderImage = (imageUrl) => imageUrl && imageUrl.startsWith && imageUrl.startsWith('https://via.placeholder.com');

const isValidImageUrl = (imageUrl) => imageUrl && imageUrl.startsWith && validHosts.indexOf(imageUrl.substr(0, 20)) > -1;

const buildCensoredUrl = (url) => {
  const { hostname, folder, file } = extractParts(url);

  return `https://${hostname}/rsz/${folder}/100x0/${file.replace('.jpg', '-b10.jpg?censored')}`;
};

const buildResizedUrl = (url, options) => {
  const {
    size,
  } = options;

  const { hostname, folder, file } = extractParts(url);

  return `https://${hostname}/rsz/${folder}/${size}x0/${file}`;
};

const buildSrcSetUrl = (originalUrl, options) => {
  const {
    title = '',
  } = options;

  switch (true) {
    case !!title && !originalUrl:
    case !!title && isPlaceholderImage(originalUrl):
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 400' preserveAspectRatio='xMidYMid meet'%3E%3Crect x='-300' y='-300' width='1000' height='1000' fill='%23fff' stroke-width='0'%3E%3C/rect%3E%3Ctext x='20' y='55%25' width='360' height='40' fill='%23000' style='font-family: Arial, Helvetica, sans-serif; font-size: 60px; text-transform: uppercase'%3E%3Ctspan textLength='360' lengthAdjust='spacing${title.length > 10 ? 'AndGlyphs' : ''}'%3E${title}%3C/tspan%3E%3C/text%3E%3C/svg%3E`;

    default: {
      return buildResizedUrl(originalUrl, options);
    }
  }
};

const processUrl = (originalUrl) => {
  if (!isValidImageUrl(originalUrl)) {
    if (!originalUrl.indexOf) {
      return originalUrl;
    }
    return originalUrl;
  }

  const srcset = {};

  for (let i = 0, length = sizes.length; i < length; i += 1) {
    const size = sizes[i];

    srcset[`${size}w`] = buildSrcSetUrl(originalUrl, {
      size,
    });
  }

  return srcset;
};

const responsiveimage = (originalUrl, options) => {
  if (originalUrl && originalUrl.replace && originalUrl.indexOf('https://m1.dvdl.net') === 0) {
    // m30 serves the same content as m1, but with resize capability
    originalUrl = originalUrl.replace('https://m1.dvdl.net', 'https://m30.dvdl.net');
  }
  if (originalUrl && originalUrl.replace && originalUrl.indexOf('https://i1.dvdl.net') === 0) {
    // i30 serves the same content as i1, but with resize capability
    originalUrl = originalUrl.replace('https://i1.dvdl.net', 'https://i30.dvdl.net');
  }
  if (originalUrl && originalUrl.replace && originalUrl.indexOf('https://i20.dvdl.net') === 0) {
    // i30 serves the same content as i20, but with resize capability
    originalUrl = originalUrl.replace('https://i20.dvdl.net', 'https://i30.dvdl.net');
  }

  switch (true) {
    default:
      return originalUrl;

    case (!originalUrl && !!options.title):
      return buildSrcSetUrl(undefined, options);

    case originalUrl && typeof originalUrl === 'string':
      return processUrl(originalUrl, options);

    case originalUrl && typeof originalUrl === 'object':
      if (
        originalUrl.default
        && typeof originalUrl.default !== 'undefined'
        && typeof originalUrl.censored !== 'undefined'
      ) {
        if (originalUrl.censored === null) {
          return {
            default: processUrl(originalUrl.default, options),
            censored: buildCensoredUrl(originalUrl.default),
          };
        }

        return {
          default: processUrl(originalUrl.default, options),
          censored: processUrl(originalUrl.censored, options),
        };
      }

      return originalUrl;
  }
};

const processAndCache = (originalUrl, options) => {
  if (typeof originalUrl === 'string' && originalUrl.indexOf('/rsz/') > -1) {
    return originalUrl;
  }

  return responsiveimage(originalUrl, options);
};

module.exports = processAndCache;



// WEBPACK FOOTER //
// ./src/_utilities/responsiveimage.js